import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {EMPTY, Observable, of} from 'rxjs';
import {EventGroup} from "@biletix/core/models/event/event-group.model";
import {RouteParameter} from "@biletix/core/common/constants/route-parameter.const";
import {catchError, mergeMap, take} from "rxjs/operators";
import {ApiResponseStatus} from "@biletix/core/models/api-response-status";
import {EventService} from "@biletix/core/services/event.service";
import {GlobalErrorHandler} from "@biletix/core/services/global-error-handler.service";
import {EventGroupPageStateService} from "@biletix/features/event-group/services/event-group-page-state.service";
import { StatusCodeResponseService } from '@biletix/core/services/status-code-response.service';
import { ApiService } from '@biletix/core/services/api.service';
import { environment } from '@biletix/env';

@Injectable({
  providedIn: 'root'
})
export class EventGroupResolver implements Resolve<EventGroup> {


  constructor(private eventService: EventService,
              private eventGroupPageStateService: EventGroupPageStateService,
              private globalErrorHandler: GlobalErrorHandler,
              private statusCodeResponseService:StatusCodeResponseService,
              private apiService: ApiService,
              private router: Router,
              @Inject(PLATFORM_ID) private platformId: string) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<EventGroup> {

    console.log("Event group resolver called",route.params);

    console.log("Event group resolver called",route.paramMap);

    return this.eventService.getEventGroup(route.params[RouteParameter.PARAMS.EVENT_GROUP_CODE])
      .pipe(
        catchError((err) => {
          //console.log("Error happened while calling findByEventCode"+err);
          this.globalErrorHandler.handleError(err);
          // this.goBack();
          return EMPTY;
        }),
        take(1),
        mergeMap(response => {
          //console.log("findByEventCode :");
          //console.log(response);
          if (response && response.status == ApiResponseStatus.SUCCESS&&response.data) {
            this.eventGroupPageStateService.setCurrentEventGroup(response.data);
            const slug = response.data.keyUrlText;
            console.log("Event group resolver. Slug is ",route.params[RouteParameter.PARAMS.SLUG]);
            
            if(!route.params[RouteParameter.PARAMS.SLUG]){
              let redirectUrl=environment.baseHref+"etkinlik-grup/"+route.params[RouteParameter.PARAMS.EVENT_GROUP_CODE]+"/"+route.params[RouteParameter.PARAMS.REGION]+"/"+route.params[RouteParameter.PARAMS.LANGUAGE]+"/" + slug;
              
              
              // Query params'ları almak
              const queryParams = route.queryParams; 

              // Query params'ları string'e çevir
              const queryString = Object.keys(queryParams).map(key => {
                return `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`;
              }).join('&');

              // Eğer query params varsa, bunları URL'ye ekle
              if (queryString) {
                redirectUrl += `?${queryString}`;
              }
              
              
              console.log("redirecting to " + redirectUrl);
              this.statusCodeResponseService.setPermanentRedirect(redirectUrl); 
            }
            //console.log("Set edildi");
            return of(response.data);
          } else { // eventCode not found
            //console.log("Set edilemedi");
            this.statusCodeResponseService.setNotFound();
            /*
            this.notificationService.error(response.errors).onShown
              .pipe(take(1))
              .subscribe(() => {
                // this.goBack();
              });
            */
           //this.router.navigateByUrl("/404.btx");

           return EMPTY;
          }
        }));
  }
}
